import React, { useState, useEffect } from "react";
import { Form, Modal, Button, Row, Col, ButtonToolbar } from 'react-bootstrap';

import { getECheckPaymentUpdates } from '../../../redux/actions/payments/paymentTransactions';
import { SearchList, TransactionTypeEnum } from '../../../models/Payment';
import Select from 'react-select';
import { IActionResult, IAppState } from '../../../redux/storeTypes';
// @ts-ignore

import FormHeader from '../../clients/components/forms/FormHeader';
import { connect, useDispatch } from "react-redux";
import moment from 'moment';
import CurrencyInput from "../../../components/currency/CurrencyInput";
import { ReportType } from "../../../models/Reports";
import { Client, ClientName, DepartmentName } from "../../../models/Client";
import { DELETE_CLIENT_BANKING_SUCCESS, getClientsAction, getClientTimezoneAction, SAVE_CLIENT_BANKING_SUCCESS } from "../../../redux/actions/clients/clients";
import { User } from "../../../models/User";
import { sendErrorToastAction } from "../../../redux/actions/toast";
import _ from 'lodash';
import { timeZonesMap } from "../../../components/Formatters";

interface IAdvancedSearch {
    formSchema: any;
    clientTimeZones: any;
    transactionType: any;
    reportType: ReportType;
    isFetching: boolean;
    searchReady: boolean;
    currentUser: User;
    clients: Array<Client>;
    clientNames: Array<ClientName>;
    departmentNames: Array<DepartmentName>;
    actionResult: IActionResult;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    totalRecords?: number;
}

const AdvancedSearch = ({ formSchema, clientTimeZones, transactionType, reportType, searchReady, isFetching, currentUser, clients, actionResult }: IAdvancedSearch) => {
    const [showModal, setShowModal] = useState(false);
    const actionToken = "AdvancedSearch";
    const dispatch = useDispatch();

    const defaultStartDate = moment().subtract(1, "day").format('YYYY-MM-DD');
    const defaultEndDate = moment().format('YYYY-MM-DD');

    const [searchList, setSearchList] = useState<SearchList>(Object.assign(new SearchList(), { startDate: defaultStartDate, endDate: defaultEndDate }));
    const [trigger, setTrigger] = useState(false);
    const [clientList, setClientList] = useState<any>([]);
    const [executeDynamicQuery, setExecuteDynamicQuery] = useState<boolean>(false);

    const search = () => {

        let _searchList = new SearchList();

        Object.entries(searchList).map(([key, value]) => {
            if (!["startDate", "endDate", "startTime", "endTime", "startAmount", "endAmount", "customSelectComponent", "departmentIds"].some(k => key === k)) {
                (_searchList[key as keyof SearchList] as keyof typeof key) = value as keyof typeof key;
            }
        })

        if (searchList.customSelectComponent && searchList.customSelectComponent?.length > 0) {
            _searchList.transactionType = searchList.customSelectComponent.map(({ value }) => `${TransactionTypeEnum[value]}`).join("|");
            if (_searchList.transactionType.includes(TransactionTypeEnum["Void"].toString())) _searchList.transactionType += "|" + TransactionTypeEnum["Reversal"];
            if (_searchList.transactionType.includes(TransactionTypeEnum["Refund"].toString())) _searchList.transactionType += "|" + TransactionTypeEnum["Return"];
        }

        const timeZones = _.uniq(_.map(clientTimeZones, 'timeZone'));
        const timeZoneUtcOffset = timeZones.map((timezone: string) => {
            const formattedTimeZone = timeZonesMap[timezone] ? `${timeZonesMap[timezone]}` : null as any
            return moment().tz(formattedTimeZone).utcOffset();
        }).sort() as any
        const userOffset = moment.tz(moment.tz.guess()).utcOffset();
        const start = moment(searchList.startDate).local().startOf('day').add(timeZoneUtcOffset[0] - userOffset, 'minutes');
        const end = moment(searchList.endDate).local().endOf('day').add(timeZoneUtcOffset.slice(-1) - userOffset, 'minutes');

        const startUtc = moment.utc(start).format('YYYY-MM-DD hh:mm:ss');
        const endUtc = moment.utc(end).format('YYYY-MM-DD hh:mm:ss');

        _searchList.createdAt = `${startUtc}<->${endUtc}`;
        _searchList.startDate = searchList.startDate;
        _searchList.endDate = searchList.endDate;

        if (executeDynamicQuery) {
            dispatch(getECheckPaymentUpdates(_searchList, actionToken, currentUser, transactionType, reportType));
        }

    }

    useEffect(() => {
        if (!clients) {
            dispatch(getClientsAction(1, 1000));
        }
        const clientDropdown = clients?.filter(clientDetails => currentUser?.userClients.some(userClient => clientDetails.msbId === userClient.clientMSBId));
        setClientList(clientDropdown);
    }, [clients]);

    useEffect(() => {
        if (!clientTimeZones) {
            dispatch(getClientTimezoneAction(actionToken));
        }
    }, [clientTimeZones]);

    useEffect(() => {
        search();
    }, [trigger, executeDynamicQuery]);

    useEffect(() => {
        if (actionResult && actionResult.result) {
            if (actionResult.result === SAVE_CLIENT_BANKING_SUCCESS || actionResult.result === DELETE_CLIENT_BANKING_SUCCESS) {
                setTrigger(!trigger);
            }
        }
    }, [actionResult]);

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (moment(searchList.startDate + ((searchList.startTime) ? "T" + searchList.startTime + ":00.000" : "T00:00:00.000")).utc() > moment(searchList.endDate + ((searchList.endTime) ? "T" + searchList.endTime + ":59.999" : "T23:59:59.999")).utc()) {
            dispatch(sendErrorToastAction(`Start date/time must be less than end date/time.`));
            return;
        }
        if (showModal) setTimeout(() => setShowModal(false), 100);
        setTrigger(!trigger);
        setExecuteDynamicQuery(true);
    };

    const clearForms = (event: any) => {
        event.preventDefault();
        setSearchList(Object.assign(new SearchList(), { startDate: defaultStartDate, endDate: defaultEndDate, clientIds: '' }));
        setTrigger(!trigger);
    }

    const onHideModal = () => {
        setTimeout(() => setShowModal(false), 100);
    }

    const getFormElement = (elementName: any, elementSchema: any) => {
        const props = {
            name: elementName,
            label: elementSchema.label,
            options: elementSchema.options
        };

        if (elementSchema.type === "select") {
            return (
                <Form.Group controlId={props.name}>
                    <Form.Label>{props.label}</Form.Label>
                    <Form.Control as="select" value={searchList[elementName as keyof SearchList]} onChange={(e: any) => setSearchList({ ...searchList, [elementName as keyof SearchList]: e.target.value })}>
                        <option key={0} value="" >Select...</option>
                        {props.options.map((optn: any, index: any) => <option key={index} value={optn.value} label={optn.label || optn.value} />)}
                    </Form.Control>
                </Form.Group>
            )
        }
        else if (elementSchema.type === "currency") {
            return (
                <Form.Group controlId={props.name}>
                    <Form.Label>{props.label}</Form.Label>
                    <CurrencyInput
                        className="form-control"
                        placeholder="$ 0.00"
                        maxLength={10}
                        decimalsLimit={2}
                        prefix="$ "
                        value={searchList[elementName as keyof SearchList]}
                        onValueChange={(value, name) => setSearchList({ ...searchList, [elementName as keyof SearchList]: value })}
                    />
                </Form.Group>
            )
        }
        else if (elementName === 'customSelectComponent') {
            return (
                <Form.Group controlId={props.name}>
                    <Form.Label>{props.label}</Form.Label>
                    <Select
                        isMulti
                        closeMenuOnSelect={false}
                        value={searchList.customSelectComponent}
                        onChange={(selected: any) => setSearchList({ ...searchList, customSelectComponent: selected })}
                        options={props.options}
                        className="react-select-container"
                        classNamePrefix="react-select"
                    />
                </Form.Group>
            )
        }
        else {
            return (
                <Form.Group controlId={props.name}>
                    <Form.Label>{props.label}</Form.Label>
                    <Form.Control type={elementSchema.type} value={searchList[elementName as keyof SearchList]} onChange={(e: any) => setSearchList({ ...searchList, [elementName as keyof SearchList]: e.target.value })} />
                </Form.Group>
            )
        }
    }

    return (
        <>
            <Form className="table-search advanced-search" onSubmit={handleSubmit}>
                <Row>
                    <>
                        <Col xl={4} lg={6} md={6} sm={12}>
                            <Form.Group controlId="startDate">
                                <Form.Label>Start date</Form.Label>
                                <Form.Control type="date" name="startDate" max={moment(defaultEndDate).format('YYYY-MM-DD')} value={searchList.startDate} onChange={(e: any) => setSearchList({ ...searchList, startDate: e.target.value })} disabled={isFetching} />
                            </Form.Group>
                        </Col>
                        <Col xl={4} lg={6} md={6} sm={12}>
                            <Form.Group controlId="endDate">
                                <Form.Label>End date</Form.Label>
                                <Form.Control type="date" name="endDate" min={moment(searchList.startDate).format('YYYY-MM-DD')} max={moment(defaultEndDate).format('YYYY-MM-DD')} value={searchList.endDate} onChange={(e) => setSearchList({ ...searchList, endDate: e.target.value })} disabled={isFetching} />
                            </Form.Group>
                        </Col>
                    </>

                    <Col xl={4} lg={12} md={12} sm={12}>
                        <ButtonToolbar>
                            <Button variant="link" onClick={() => setShowModal(true)} disabled={isFetching}>Advanced Search</Button>
                            <Button variant="outline-secondary" onClick={clearForms} disabled={isFetching}>Reset</Button>
                            <Button type="submit" disabled={isFetching}>Search</Button>
                        </ButtonToolbar>
                    </Col>
                </Row>
            </Form>

            <Modal show={showModal} onHide={onHideModal} size="lg" className="advanced-search-modal">
                <Modal.Header closeButton />
                <Modal.Body>
                    <FormHeader title="Advanced Search" description="Please enter the details below to narrow your search results" />
                    <Form className="advanced-search-form" onSubmit={handleSubmit}>
                        <Row>
                            <Col>
                                <Form.Group controlId="startDate">
                                    <Form.Label>Start date</Form.Label>
                                    <Form.Control type="date" name="startDate" max={moment(defaultEndDate).format('YYYY-MM-DD')} value={searchList.startDate} onChange={(e) => setSearchList({ ...searchList, startDate: e.target.value })} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="endDate">
                                    <Form.Label>End date</Form.Label>
                                    <Form.Control type="date" name="endDate" min={moment(searchList.startDate).format('YYYY-MM-DD')} max={moment(defaultEndDate).format('YYYY-MM-DD')} value={searchList.endDate} onChange={(e) => setSearchList({ ...searchList, endDate: e.target.value })} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            {Object.keys(formSchema).map((key, ind) => (
                                <div className="col-sm-6" key={key}>
                                    {getFormElement(key, formSchema[key])}
                                </div>
                            ))}
                        </Row>
                        <div className="advanced-search-footer">
                            <Button type="submit">
                                Search
                            </Button>
                            <Button form='orgUserSubmit' className="orgUserFooterCancel" variant="link" onClick={() => setShowModal(false)}>
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const mapStateToProps = (state: IAppState) => {
    return {
        clients: state.clients.currentPage?.data,
        currentUser: state.auth.currentUser,
        clientTimeZones: state.clients.clientTimezones,
        clientNames: state.clients.clientNames,
        departmentNames: state.clients.departmentNames,
        actionResult: state.clients.actionResult,
    };
};

export default connect(mapStateToProps)(AdvancedSearch);